import { FC } from "react";
import ActivityBody from "../activity-body";
import { ActivityBodyProps } from "../activity-body/types";

const ActivityFooter: FC<ActivityBodyProps> = ({
  children,
  props,
  className = "",
  style = {},
}) => {
  return (
    <ActivityBody
      className={className}
      props={props}
      style={{ marginBottom: "1rem", ...style }}
    >
      {children}
    </ActivityBody>
  );
};

export default ActivityFooter;
